import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  TextField,
  Switch,
  FormControlLabel,
  Grid,
  Button,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useGrowSetup } from '../GrowSetupContext';
import { AuthContext } from './signin/AuthContext';

export default function ActorConfigCard({
  grow_setup,
  token,
  measure = '',       // wenn leer, Dropdown anzeigen
  initialConfig = {},
}) {
  const theme = useTheme();
  const { grow_setup: gs } = useGrowSetup();
  const { token: authToken } = useContext(AuthContext);
  const [selectedMeasure, setSelectedMeasure] = useState(measure || '');
  const [email, setEmail] = useState(initialConfig.email || '');
  const [phone, setPhone] = useState(initialConfig.phonenumber || '');
  const [upper, setUpper] = useState(initialConfig.upperboundary || 0);
  const [lower, setLower] = useState(initialConfig.lowerboundary || 0);
  const [activeEmail, setActiveEmail] = useState(initialConfig.is_active_email || false);
  const [activePhone, setActivePhone] = useState(initialConfig.is_active_phone || false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Titel fallback
  const title = selectedMeasure
    ? selectedMeasure.charAt(0).toUpperCase() + selectedMeasure.slice(1)
    : 'Neue Benachrichtigung';

  const handleSave = async () => {
    try {
      await axios.post(
        '/save_alert_config',
        {
          grow_setup_id: gs,
          measure: selectedMeasure,
          upperboundary: upper,
          lowerboundary: lower,
          email,
          phonenumber: phone,
          isactive_email: activeEmail,
          isactive_phone: activePhone,
        },
        { headers: { Authorization: 'Bearer ' + authToken } }
      );
      setSnackbar({ open: true, message: 'Konfiguration gespeichert', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: 'Fehler beim Speichern', severity: 'error' });
    }
  };

  return (
    <Card sx={{ maxWidth: 360, m: 1 }}>
      <CardHeader
        title={title}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        {/* Dropdown nur anzeigen, wenn measure leer */}
        {!measure && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="measure-label">Messwert</InputLabel>
            <Select
              labelId="measure-label"
              value={selectedMeasure}
              label="Messwert"
              onChange={(e) => setSelectedMeasure(e.target.value)}
            >
              <MenuItem value="temperatur">Temperatur</MenuItem>
              <MenuItem value="luftfeuchte">Luftfeuchte</MenuItem>
              <MenuItem value="co2">CO2</MenuItem>
            </Select>
          </FormControl>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={activeEmail}
                  onChange={(e) => setActiveEmail(e.target.checked)}
                />
              }
              label="Email aktiv"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="WhatsApp"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={activePhone}
                  onChange={(e) => setActivePhone(e.target.checked)}
                />
              }
              label="WhatsApp aktiv"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Untere Grenze"
              type="number"
              value={lower}
              onChange={(e) => setLower(Number(e.target.value))}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Obere Grenze"
              type="number"
              value={upper}
              onChange={(e) => setUpper(Number(e.target.value))}
            />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Speichern
        </Button>
      </CardActions>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
}

ActorConfigCard.propTypes = {
  grow_setup: PropTypes.number,
  token: PropTypes.string,
  measure: PropTypes.string,
  initialConfig: PropTypes.shape({
    email: PropTypes.string,
    phonenumber: PropTypes.string,
    upperboundary: PropTypes.number,
    lowerboundary: PropTypes.number,
    is_active_email: PropTypes.bool,
    is_active_phone: PropTypes.bool,
  }),
};
